export default {
  functionKey: "MINUSCULE",
  title: "MINUSCULE",
  group: "Texte",
  origin: [],
  target: [],
  isStarred: false,

  generate(destination, origin, args, isArgumentCol) {
    const code = `${destination} = ${origin}.toLowerCase();`;
    return { displayCode: code, safeCode: code };
  }
}
